<template>
  <ion-page>
    <!--content start -->
    <ion-content>
      <div class="container-support">
        <ion-row>
          <ion-col size="4">
            <router-link to="/list/account-related" replace
              ><ion-icon class="back-icon" src="assets/icon/arrow-left.svg"
            /></router-link>
          </ion-col>
          <ion-col size="8">
            <span class="h1-od">Support center</span>
          </ion-col>
        </ion-row>
      </div>
      <ion-row class="support-row">
        <ion-col size="12">
          <span class="support-heading">How do I reset my Password?</span>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <p class="support-p">Follow these steps to reset your password:</p>
          <ul class="support-p">
            <li>
              Start Password Reset: On the app's login screen, click the "Reset
              your Password"
            </li>
            <li>
              Enter Your Email: In the provided field, enter your email address
              associated with your account. Make sure it's entered correctly.
            </li>
            <li>
              Check Email: An Email will be sent with a link to the Password
              Reset page.
            </li>
            <li>
              Create a New Password: After clicking on the Reset Password link,
              you'll be prompted to create a new password. Follow these
              guidelines:
            </li>
            <li>1. Use a combination of uppercase and lowercase letters.</li>
            <li>2. Use a combination of uppercase and lowercase letters.</li>
            <li>
              3 .Make it at least 8-12 characters long. Avoid using easily
              guessable information like your name or birthdate.
            </li>
            <li>
              Confirm Your New Password: Re-enter the new password to confirm
              it. Make sure both entries match.
            </li>
            <li>
              Save Your New Password: Click the "Continue" button to finalize
              the password reset. Your new password is now active.
            </li>
            <li>
              Login with Your New Password: Return to the login screen and enter
              your username or email along with the new password you just
              created.
            </li>
          </ul>
          <p class="support-p">
            Congratulations! You've successfully reset your password and can now
            access your account.
          </p>
        </ion-col>
      </ion-row>
      <hr class="support-row" />
      <!-- content end -->
    </ion-content>
  </ion-page>
</template>
<style scoped>
.container-support {
  padding-top: 10%;
  padding-bottom: 3%;
  padding-left: 5%;
  padding-right: 5%;
}
.back-icon {
  height: 20px;
  width: 20px;
}
.h1-od {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: #1b1b1b;
}
.support-row {
  border-top: 1px solid #f3f3f3;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 3%;
  padding-bottom: 3%;
}
.support-heading {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  color: #1b1b1b;
  display: block;
  padding-top: 5px;
}
.support-txt {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
  display: block;
  padding-top: 5px;
}
.arrowright-icon {
  text-align: right;
  padding-top: 8px;
}
.position-right {
  position: absolute;
  right: 20px;
}
.support-p {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #666666;
  padding-left: 5%;
  padding-right: 5%;
}
</style>
<script>
import { defineComponent } from "vue";
import {
  IonRow,
  IonCol,
  IonButton,
  IonPage,
  IonContent,
  IonIcon,
} from "@ionic/vue";

export default defineComponent({
  name: "SupportListPage",
  components: {
    IonRow,
    IonCol,
    IonButton,
    IonPage,
    IonContent,
    IonIcon,
  },
});
</script>
